import React from "react";
//Limitless imports
import { POLICY_APP_INFO, POLICY_MFA_REQUIRED, LoginScreenLayout } from "@limitless/portal";
import { useExpertProfileContext, useAuthenticationContext, useLoginWrapperContext } from "@limitless/expert";
import { history } from "@limitless/navigation";
import MobileViewScreen from "./MobileViewScreen";
import { usePageViewRecorder } from "@limitless/analytics";

const MOBILE_RESOLUTION = "(max-device-width: 480px)";

const LoginScreen = () => {
    const mq = window.matchMedia(MOBILE_RESOLUTION);
    const [isMobile, setIsMobile] = React.useState(mq.matches);
    const [viewWebAppAnyway, setViewWebAppAnyway] = React.useState(false);

    const { mfaLoginState } = useLoginWrapperContext();
    const { canUserAccess, profile } = useExpertProfileContext();
    const {
        auth: { authenticated },
        isSignInActive
    } = useAuthenticationContext();
    usePageViewRecorder("Sign In");

    React.useEffect(() => {
        mq.removeEventListener("change", handleScreenResolutionChange);
        mq.addEventListener("change", handleScreenResolutionChange);

        return () => {
            mq.removeEventListener("change", handleScreenResolutionChange);
        };
    }, [isMobile]);

    React.useEffect(() => {
        //isSignInActive = we're viewing the sign up
        if (authenticated && profile.userName && isSignInActive) {
            if (canUserAccess(POLICY_MFA_REQUIRED) && profile && !profile?._phoneDetails?.isPhoneVerified) {
                history.push({
                    pathname: "/mfa-setup",
                    state: { profile }
                });
            } else if (canUserAccess(POLICY_APP_INFO)) {
                history.push("/portal-selection");
            } else {
                history.push("/tasklist");
            }
        }
    }, [authenticated, profile, mfaLoginState]);

    const handleScreenResolutionChange = () => {
        if (mq.matches && !isMobile) {
            setIsMobile(true);
        } else if (isMobile) {
            setIsMobile(false);
        }
    };
    
    return (
        <>
            {isMobile && !viewWebAppAnyway ? (
                <MobileViewScreen handleViewDesktopAnyway={() => setViewWebAppAnyway(true)} />
            ) : (
                <LoginScreenLayout isManagerPortal={false} />
            )}
        </>
    );
};

export default LoginScreen;
